<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Project Details" />
            <ProjectDetails />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ProjectDetails from '../ProjectDetails/ProjectDetails'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ProjectDetailsPage',
    components: {
        NavBar,
        PageTitle,
        ProjectDetails,
        FooterComp,
    }
}
</script>